<template>
  <Modal title="Navigation Improvements" :hide-footer="true" @close="close">
    <template #body>
      <NavigationImprovementsContent btn-variant="primary" />
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/display/Modal";
import NavigationImprovementsContent from "@/components/smart/modals/NavigationImprovementsContent";

export default {
  name: "NavigationImprovements",
  components: {
    NavigationImprovementsContent,
    Modal,
  },
  emits: ["close"],
  setup: (props, { emit }) => ({
    close: () => emit("close"),
  }),
};
</script>
